import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';
import logo from '../imgs/logo.svg';

function Navbar({ className = '' }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isResizing, setIsResizing] = useState(false);
  const navRef = useRef(null);
  const resizeTimerRef = useRef(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Handle viewport resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      
      // Set resizing flag to disable transitions
      setIsResizing(true);
      
      // Clear existing timer
      if (resizeTimerRef.current) {
        clearTimeout(resizeTimerRef.current);
      }
      
      // Close menu when switching from mobile to desktop
      if (!mobile && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
      
      // Re-enable transitions after resize completes
      resizeTimerRef.current = setTimeout(() => {
        setIsResizing(false);
      }, 100);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimerRef.current) {
        clearTimeout(resizeTimerRef.current);
      }
    };
  }, [isMobileMenuOpen]);

  // Handle click outside to close menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && navRef.current && !navRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  return (
    <nav className={className} ref={navRef}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="OneAligned logo" width="60" height="60" />
        </Link>

        <div className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''} ${isResizing ? 'no-transition' : ''}`}>
          <Link to="/" className="navbar-link" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
          <Link to="/about" className="navbar-link" onClick={() => setIsMobileMenuOpen(false)}>About</Link>
          <Link to="/services" className="navbar-link" onClick={() => setIsMobileMenuOpen(false)}>Services</Link>
          <Link to="/strategy" className="navbar-link" onClick={() => setIsMobileMenuOpen(false)}>ALIGN</Link>
          <Link to="/careers" className="navbar-link" onClick={() => setIsMobileMenuOpen(false)}>Careers</Link>
          <Link to="/blog" className="navbar-link" onClick={() => setIsMobileMenuOpen(false)}>Insights</Link>
          <Link to="/contact" className="navbar-button-active" onClick={() => setIsMobileMenuOpen(false)}>Contact Us</Link>
        </div>

        <Link to="/contact" className="navbar-button-inactive" onClick={() => setIsMobileMenuOpen(false)}>Contact Us</Link>

        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
